const endpointBase = process.env.REACT_APP_HOST_API_KEY;
const isProduction = process.env.REACT_APP_PRODUCTION == 'true';

// export const isOX =
//     !isProduction||
//     window.location.hostname === 'ox-crm-admin.gen-x.dev' ||
//     window.location.hostname === 'ox-crm-client.gen-x.dev';
export const isDev =
    window.location.hostname == 'localhost' ||
    window.location.hostname == 'bull-crm-admin.gen-x.dev' ||
    window.location.hostname == 'bull-crm-client.gen-x.dev' ||
    window.location.hostname == 'bull-crm-sale.gen-x.dev' ||
    window.location.hostname == 'ox-crm-sale.gen-x.dev' ||
    window.location.hostname == 'ox-crm-client.gen-x.dev' ||
    window.location.hostname == 'ox-crm-admin.gen-x.dev'
// process.env.REACT_APP_IS_DEV;

// import LogoIcon from 'assets/images/OXLogo3.jpg';
import BullKingLogoShortIcon from 'assets/images/Logo-short.png';
import BullKingLogoLongIcon from 'assets/images/Logo-long2.png';
import FoxIcon from 'assets/images/Fox.jpg';
import FoxLongIcon from 'assets/images/FoxLong.jpg';
import LogoIcon from 'assets/images/ox_dp_new.png';

const appConfig = {
    name: '',
    displayName: '',
    ico: isDev ? 'favicon.ico' : 'favicon.ico',
    logo: isDev ? LogoIcon : LogoIcon,
    logoShort: isDev ? LogoIcon : LogoIcon,
    apiEndpoint: `${endpointBase}/client/v1`,
    adminApiEndpoint: `${endpointBase}/admin/v1`,
    saleApiEndpoint: `${endpointBase}/sale/v1`,
    authApiEndpoint: `${endpointBase}/client/auth/v1`,
    adminAuthApiEndpoint: `${endpointBase}/admin/auth/v1`,
    explorerApiEndpoint: `${endpointBase}/explorer/v1`,
    // Google has banned the dev reCAPTCHA key for the dev domains, so the
    // widget is not rendered there. The register page gates both rendering and
    // the submit button on this key, so an empty value turns the check off.
    // Production keeps the key from REACT_APP_RECAPTCHA_SITE_KEY.
    reCaptchaSiteKey: isDev ? '' : process.env.REACT_APP_RECAPTCHA_SITE_KEY,

    storePrefix: process.env.REACT_APP_STORE_PREFIX,
    appPermissionControl: process.env.REACT_APP_PERMISSION_CONTROL
        ? process.env.REACT_APP_PERMISSION_CONTROL.split(',')
        : ['USER', 'ADMIN', 'SALE'],
    // KYC PDF 导出走后端 puppeteer 渲染；改回 false 并重新构建即可切回旧的前端导出
    kycExportBackend: true,
    isClient: process.env.REACT_APP_PERMISSION_CONTROL.split(',').includes('USER'),
};
export default appConfig;
